var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[(this.$router.currentRoute.name !== 'login' &&
    this.$router.currentRoute.name !== 'callback'
    )?[_c('AppBar')]:_vm._e(),_c('v-main',[(this.$router.currentRoute.name === 'login')?[_c('v-container',{staticClass:"pa-0 ma-0"},[_c('router-view')],1)]:[_c('v-container',{staticClass:"ma-0 pt-8 px-16",staticStyle:{"max-width":"4000px !important"}},[_c('router-view')],1)]],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }